import PropTypes from 'prop-types';
import React from 'react';
import Modal from '@glu/modal-react';
import withLocale from 'components/withLocale/withLocale';
import PromptContent from './PromptContent';

export function PromptComponent({ classes, locale, onCancel, onConfirm }) {
  return (
    <Modal
      type="ERROR"
      open
      onClose={onCancel}
      dataQa="route-guard-modal"
      ariaLabelledby="modalHeader"
      header={locale['common.leavePage']}
    >
      <PromptContent onCancel={onCancel} onConfirm={onConfirm} />
    </Modal>
  );
}

PromptComponent.propTypes = {
  locale: PropTypes.objectOf(PropTypes.string),
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
};
PromptComponent.defaultProps = {
  locale: PropTypes.objectOf(PropTypes.string),
  onCancel() {},
  onConfirm() {}
};

export default withLocale(PromptComponent);
